/* eslint-disable @typescript-eslint/no-explicit-any */
import "react-toastify/dist/ReactToastify.css";
import { api } from "@/services";
// Se seu barrel ( "@/services" ) reexporta essas funções, mantenha a linha abaixo.
// Caso contrário, altere para o caminho real, ex.: "@/utils/authSession".
import { deleteSessionStorage, saveTokenToSessionStorage } from "@/services";

const BASE = "/authenticate";

type AuthResponse = {
  access_token: string;
  expireIn: string | number;
  // campos adicionais que sua API possa retornar:
  user?: any;
  token_type?: string;
};

export async function signIn({
  email,
  password,
}: {
  email: string;
  password: string;
}): Promise<AuthResponse> {
  try {
    const { data } = await api.post<AuthResponse>(BASE, { email, password });

    // Garante que só salva se vier token válido
    if (data?.access_token) {
      saveTokenToSessionStorage(data.access_token, String(data.expireIn));
    }

    return data;
  } catch (err) {
    // propaga para a tela tratar 429 e demais erros
    throw err;
  }
}

export async function signOut(): Promise<void> {
  await deleteSessionStorage();
}